import React from "react";
import {
  ProfitDashboardIcon,
  ProfitMerchantsIcon,
  ProfitPayoutsIcon,
  ProfitReportsIcon,
  ProfitRevenueIcon,
  ProfitSettingsIcon,
} from "../components/ProfitIcons";

export const profitNavItems = [
  { key: "dashboard", label: "Dashboard", title: "Dashboard", path: "/profit/dashboard", icon: ProfitDashboardIcon },
  { key: "merchants", label: "Merchants", title: "Merchants", path: "/profit/merchants", icon: ProfitMerchantsIcon },
  { key: "revenue", label: "Revenue", title: "Revenue", path: "/profit/revenue", icon: ProfitRevenueIcon },
  { key: "payouts", label: "Payouts", title: "Payouts", path: "/profit/payouts", icon: ProfitPayoutsIcon },
  { key: "reports", label: "Reports", title: "Reports", path: "/profit/reports", icon: ProfitReportsIcon },
  { key: "settings", label: "Settings", title: "Settings", path: "/profit/settings", icon: ProfitSettingsIcon },
];

export const profitPortalMeta = {
  companyName: "AMFUTURE PTE. LTD.",
  accountId: "PTR-2024-001",
  partnerTier: "Gold",
  avatar: "AF",
  loginEmail: "jane@amfuture.sg",
  loginPassword: "partner-demo",
  licenseText: "Licensed Payment Institution · MAS Licence No. PS20200248",
  footer:
    "© 2026 Uniweb Pte. Ltd. · Licensed Payment Institution (Singapore) · MAS PS20200248",
  systemStatus: "v2.5.0 · All systems operational",
};

export const profitPeriodOptions = ["Q1 2026", "Q4 2025"];
export const profitCurrentPeriod = "Q1 2026";

export const profitRevenueModelText =
  "You receive 80% of the MDR spread between the base rate and final merchant rate. Minimum quarterly payout: SGD 1,000.";

export const profitDashboardKpis = [
  { label: "Total Revenue (Q1)", value: "$1,309", stripeClassName: "profit-stripe-green", metaBadge: "profit-badge-green", metaLabel: "+24.5%", metaText: "vs Q4 2025" },
  { label: "Your Share (80%)", value: "$1,047", stripeClassName: "profit-stripe-blue", metaBadge: "profit-badge-green", metaLabel: "+24.5%", metaText: "earnings" },
  { label: "Active Merchants", value: "21", stripeClassName: "profit-stripe-amber", metaBadge: "profit-badge-green", metaLabel: "+3", metaText: "new this quarter" },
  { label: "Total Volume", value: "$124.4K", stripeClassName: "profit-stripe-gold", metaBadge: "profit-badge-blue", metaLabel: "Avg $5.9K", metaText: "per merchant" },
];

export const profitRevenueKpis = [
  { label: "Q1 2026 Revenue", value: "$1,309", stripeClassName: "profit-stripe-green", metaBadge: "profit-badge-green", metaLabel: "+28.4%", metaText: "vs Q4" },
  { label: "Your Share (80%)", value: "$1,047", stripeClassName: "profit-stripe-blue", metaBadge: "profit-badge-green", metaLabel: "+28.4%", metaText: "vs Q4" },
  { label: "Avg MDR Spread", value: "1.07%", stripeClassName: "profit-stripe-amber", metaBadge: "profit-badge-blue", metaLabel: "Across", metaText: "all merchants" },
  { label: "Total Volume", value: "$124.4K", stripeClassName: "profit-stripe-gold", metaBadge: "profit-badge-green", metaLabel: "+15.2%", metaText: "vs Q4" },
];

export const monthlyRevenue = [
  { month: "Oct 2025", share: 820 },
  { month: "Nov 2025", share: 890 },
  { month: "Dec 2025", share: 815 },
  { month: "Jan 2026", share: 336 },
  { month: "Feb 2026", share: 366 },
  { month: "Mar 2026", share: 135 },
];

export const monthlyPerformance = [
  { month: "January 2026", revenue: 420, share: 336, width: "70%" },
  { month: "February 2026", revenue: 458, share: 366, width: "85%" },
  { month: "March 2026 (MTD)", revenue: 169, share: 135, width: "35%" },
];

export const spreadSections = [
  {
    title: "High Spread (>1.0%)",
    color: "#1e3a8a",
    items: [
      { name: "A Kitchen@Taman Jurong", spread: "1.46% · $186", width: "100%" },
      { name: "A Kitchen@J10", spread: "1.25% · $155", width: "85%" },
      { name: "Baipule", spread: "1.30% · $123", width: "89%" },
    ],
  },
  {
    title: "Mid Spread (0.7–1.0%)",
    color: "#166534",
    items: [
      { name: "DELIVERY CHINATOWN", spread: "0.90% · $173", width: "62%" },
      { name: "Liu Zhou Nv Xu", spread: "0.82% · $64", width: "56%" },
    ],
  },
  {
    title: "Lower Spread (<0.7%)",
    color: "#92400e",
    items: [
      { name: "JIU FU PTE. LTD.", spread: "0.72% · $7", width: "49%" },
      { name: "Drunk N Jump", spread: "0.59% · $27", width: "40%" },
    ],
  },
];

export const profitMerchants = [
  { id: "MER-000001", name: "JIU FU PTE. LTD.", company: "JIU FU PTE. LTD.", status: "Active", onboarded: "2025-04-03", baseMDR: 1.3, finalMDR: 2.02, spread: 0.72, volume: 1308.33, txns: 188, revenue: 9.36, share: 7.49 },
  { id: "MER-000002", name: "HAOLIGHT PTE. LTD.", company: "HAOLIGHT PTE. LTD.", status: "Active", onboarded: "2025-11-11", baseMDR: 2.2, finalMDR: 3.36, spread: 1.16, volume: 384.87, txns: 1012, revenue: 4.45, share: 3.56 },
  { id: "MER-000003", name: "Qiang Sheng@Changi", company: "东方美食QIANG SHENG 10", status: "Active", onboarded: "2025-11-03", baseMDR: 2.2, finalMDR: 2.73, spread: 0.53, volume: 2707.49, txns: 459, revenue: 14.23, share: 11.39 },
  { id: "MER-000004", name: "DELIVERY CHINATOWN", company: "DELIVERYCHINATOWN PTE. LTD.", status: "Active", onboarded: "2025-05-26", baseMDR: 1.3, finalMDR: 2.2, spread: 0.9, volume: 23931.08, txns: 4934, revenue: 216.26, share: 173.01 },
  { id: "MER-000005", name: "Baipule", company: "BAIPULE PTE. LTD.", status: "Active", onboarded: "2025-09-11", baseMDR: 2.7, finalMDR: 4.0, spread: 1.3, volume: 11812.67, txns: 922, revenue: 153.6, share: 122.88 },
  { id: "MER-000006", name: "Liu Zhou Nv Xu@Bugis", company: "LIUZHOUNVXU (BUGIS) PTE. LTD.", status: "Active", onboarded: "2025-03-15", baseMDR: 1.3, finalMDR: 2.12, spread: 0.82, volume: 9712.09, txns: 2423, revenue: 79.58, share: 63.67 },
  { id: "MER-000007", name: "Drunk N Jump", company: "DRUNK N JUMP PTE. LTD.", status: "Active", onboarded: "2025-10-23", baseMDR: 2.7, finalMDR: 3.29, spread: 0.59, volume: 5767.91, txns: 1218, revenue: 34.04, share: 27.23 },
  { id: "MER-000008", name: "JINCHENGSG PTE. LTD.", company: "JINCHENGSG PTE. LTD.", status: "Active", onboarded: "2025-12-14", baseMDR: 1.3, finalMDR: 2.15, spread: 0.85, volume: 5232.11, txns: 872, revenue: 44.66, share: 35.73 },
  { id: "MER-000009", name: "Good Cheer Pro", company: "GOOD CHEER PRO PTE. LTD.", status: "Active", onboarded: "2025-08-05", baseMDR: 2.7, finalMDR: 3.57, spread: 0.87, volume: 2696.6, txns: 341, revenue: 23.41, share: 18.73 },
  { id: "MER-000010", name: "STARHUB", company: "STARHUB MOBILE PTE LTD", status: "Active", onboarded: "2025-12-10", baseMDR: 1.3, finalMDR: 2.22, spread: 0.92, volume: 609.6, txns: 401, revenue: 5.62, share: 4.49 },
  { id: "MER-000011", name: "A Kitchen@J10", company: "JSCHEFFLERA Pte Ltd", status: "Active", onboarded: "2025-04-16", baseMDR: 2.2, finalMDR: 3.45, spread: 1.25, volume: 15567.0, txns: 3123, revenue: 193.98, share: 155.18 },
  { id: "MER-000012", name: "Xiao Long Kan@Westgate", company: "XIAO LONG KAN DINING", status: "Active", onboarded: "2025-01-23", baseMDR: 1.3, finalMDR: 2.53, spread: 1.23, volume: 1307.77, txns: 75, revenue: 16.08, share: 12.87 },
  { id: "MER-000013", name: "Xiao Long Kan@Orchard", company: "XIAO LONG KAN DINING", status: "Active", onboarded: "2025-10-12", baseMDR: 1.3, finalMDR: 2.76, spread: 1.46, volume: 3604.51, txns: 160, revenue: 52.5, share: 42.0 },
  { id: "MER-000014", name: "FASIXI", company: "FASIXI PTE. LTD.", status: "Active", onboarded: "2025-11-22", baseMDR: 1.0, finalMDR: 2.42, spread: 1.42, volume: 1508.23, txns: 650, revenue: 21.39, share: 17.11 },
  { id: "MER-000015", name: "The Providore@PLQ", company: "THE PROVIDORE SINGAPORE", status: "Active", onboarded: "2025-01-04", baseMDR: 1.3, finalMDR: 2.49, spread: 1.19, volume: 259.93, txns: 48, revenue: 3.09, share: 2.47 },
  { id: "MER-000016", name: "Zhou Ji Chuan Chuan Xiang", company: "BLACK BRO PTE. LTD.", status: "Active", onboarded: "2025-08-12", baseMDR: 1.3, finalMDR: 1.9, spread: 0.6, volume: 5708.15, txns: 791, revenue: 34.06, share: 27.25 },
  { id: "MER-000017", name: "A Kitchen@Taman Jurong", company: "A KITCHEN PTE LTD", status: "Active", onboarded: "2025-11-12", baseMDR: 2.7, finalMDR: 4.16, spread: 1.46, volume: 15978.66, txns: 1796, revenue: 232.75, share: 186.2 },
  { id: "MER-000018", name: "WO JIAO XIANG", company: "WOJIAOXIANG PTE. LTD.", status: "Active", onboarded: "2025-06-20", baseMDR: 2.7, finalMDR: 3.81, spread: 1.11, volume: 1306.29, txns: 192, revenue: 14.51, share: 11.61 },
  { id: "MER-000019", name: "LAN 111 (counter 1)", company: "LAN 111 CATERING PTE. LTD.", status: "Active", onboarded: "2025-03-09", baseMDR: 1.3, finalMDR: 2.57, spread: 1.27, volume: 2608.12, txns: 1175, revenue: 33.25, share: 26.6 },
  { id: "MER-000020", name: "A Kitchen@201 Kim Tian", company: "JSCHEFFLERA Pte Ltd", status: "Active", onboarded: "2025-08-28", baseMDR: 2.2, finalMDR: 3.54, spread: 1.34, volume: 5096.36, txns: 940, revenue: 68.17, share: 54.53 },
  { id: "MER-000021", name: "Good Cheer Fiesta", company: "Good Cheer Fiesta Pte Ltd", status: "Active", onboarded: "2025-12-01", baseMDR: 2.2, finalMDR: 2.94, spread: 0.74, volume: 7335.37, txns: 823, revenue: 54.14, share: 43.31 },
];

export const profitReportCards = [
  { title: "Quarterly Summary", icon: "document", description: "Revenue, volume, and earnings breakdown by quarter.", action: "Download Q1 2026" },
  { title: "Merchant Performance", icon: "performance", description: "Per-merchant volume, spread, and share breakdown.", action: "Download Q1 2026" },
  { title: "Payout Statement", icon: "payout", description: "All payout batches with revenue share details.", action: "Download Q1 2026" },
];

export const profitReportHistory = [
  { report: "Quarterly Summary", period: "Q1 2026", generated: "1 Apr 2026, 08:00", status: "Ready" },
  { report: "Merchant Performance", period: "Q1 2026", generated: "1 Apr 2026, 08:10", status: "Ready" },
  { report: "Quarterly Summary", period: "Q4 2025", generated: "1 Jan 2026, 08:00", status: "Ready" },
];

export const profitSettingsColumns = [
  [
    {
      title: "Partner Information",
      rows: [
        ["Company Name", "AMFUTURE PTE. LTD."],
        ["Partner ID", "PTR-2024-001", "profit-mono"],
        ["UEN", "202243686M", "profit-mono"],
        ["Contact Email", "jane@amfuture.sg"],
        ["Phone", "+65 88275109"],
      ],
      button: "Request Update",
    },
    {
      title: "Security",
      rows: [
        ["Two-Factor Auth", "Enabled", "status-enabled"],
        ["Session Timeout", "30 minutes"],
        ["IP Allowlist", "Not configured"],
      ],
      buttons: ["Manage 2FA", "Change Password"],
    },
  ],
  [
    {
      title: "Agreement Details",
      rows: [
        ["Agreement Date", "16 Dec 2024"],
        ["Partner Tier", "Gold", "profit-tier-gold"],
        ["Revenue Share", "80%"],
        ["Payment Cycle", "Quarterly"],
        ["Min. Payout", "SGD 1,000.00", "profit-mono"],
        ["Agreement Status", "Active", "status-active"],
      ],
    },
    {
      title: "Notifications",
      rows: [
        ["Payout Confirmation", "ON", "profit-badge-green"],
        ["New Merchant Onboarded", "ON", "profit-badge-green"],
        ["Quarterly Report", "ON", "profit-badge-green"],
        ["Threshold Alerts", "OFF", "profit-badge-amber"],
      ],
      button: "Edit Notifications",
    },
  ],
];

export const profitPayoutKpis = [
  { label: "Pending Payout", value: "$1,047", stripeClassName: "profit-stripe-amber", detail: "Due: 30 Apr 2026" },
  { label: "Last Payout", value: "SGD 0", stripeClassName: "profit-stripe-blue", detail: "First payout pending" },
  { label: "Lifetime Earnings", value: "$1,047", stripeClassName: "profit-stripe-green", detail: "All-time partner share" },
  { label: "Payment Cycle", value: "Quarterly", stripeClassName: "profit-stripe-gold", detail: "Every 90 days" },
];

export const profitPayoutSummary = {
  nextMessage:
    "SGD 1,047.31 will be processed on April 30, 2026 for Q1 2026 performance.",
  accumulated: "SGD 1,047.31",
  threshold: "SGD 1,000.00",
  progressText: "Threshold met — payout scheduled",
  nextDate: "30 Apr 2026",
  paymentCycle: "Quarterly",
  revenueShare: "80%",
};

export const profitPayoutRows = [
  {
    period: "Q1 2026",
    periodDetail: "Jan – Mar 2026",
    revenue: "SGD 1,309.14",
    sharePercent: "80%",
    payoutAmount: "SGD 1,047.31",
    dueDate: "30 Apr 2026",
    status: "pending",
    statusLabel: "Pending",
  },
];

export const profitBankDetails = [
  ["Bank", "DBS Bank Singapore"],
  ["Account (masked)", "••••-••••-6612", "profit-mono"],
  ["Account Name", "AMFUTURE PTE. LTD."],
];

export function formatProfitCurrency(value, digits) {
  return "SGD " + Number(value).toLocaleString("en-SG", {
    minimumFractionDigits: typeof digits === "number" ? digits : 2,
    maximumFractionDigits: typeof digits === "number" ? digits : 2,
  });
}

export function formatProfitCurrencyCompact(value) {
  if (value >= 1000) {
    return "SGD " + (value / 1000).toFixed(1) + "K";
  }

  return formatProfitCurrency(value);
}

export function renderProfitMeta(kpi) {
  return (
    <React.Fragment>
      <span className={"profit-badge " + kpi.metaBadge}>{kpi.metaLabel}</span>
      {kpi.metaText}
    </React.Fragment>
  );
}
